import * as React from 'react';

import { cn } from '@/utils';

export type BadgeProps = React.HTMLAttributes<HTMLSpanElement> & {
  variant?:
    | 'blue'
    | 'white'
    | 'black'
    | 'hem-x'
    | 'red-gloss'
    | 'red-matte'
    | 'green-gloss'
    | 'green-matte'
    | 'yellow-gloss'
    | 'yellow-matte'
    | 'success'
    | 'error'
    | 'warning'
    | 'outline'
    | 'ghost';
};

export function Badge({ className, variant = 'blue', ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border border-black-100 bg-black-100 px-2 py-0.5 text-sm font-bold tracking-wide text-black',
        {
          'border-transparent bg-blue text-white': variant === 'blue',
          'border-transparent bg-white text-black': variant === 'white',
          'border-transparent bg-black text-white': variant === 'black',
          'border-transparent bg-hem-x text-white': variant === 'hem-x',
          'border-transparent bg-red-gloss text-white': variant === 'red-gloss',
          'border-transparent bg-red-matte text-red-gloss':
            variant === 'red-matte',
          'border-transparent bg-green-gloss text-white':
            variant === 'green-gloss',
          'border-transparent bg-green-matte text-green-gloss':
            variant === 'green-matte',
          'border-transparent bg-yellow-gloss text-black':
            variant === 'yellow-gloss',
          'border-transparent bg-yellow-matte text-black':
            variant === 'yellow-matte',
          'border-transparent bg-success text-white': variant === 'success',
          'border-transparent bg-error text-white': variant === 'error',
          'border-transparent bg-warning text-black': variant === 'warning',
          'border-blue-100 bg-transparent text-black': variant === 'outline',
          'border-transparent bg-transparent text-black': variant === 'ghost',
        },
        className,
      )}
      {...props}
    />
  );
}
